import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";

export default function CanvasOptions() {
  return (
    <div className="Gallery-Wraps-2 retouching">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          // data-background="assets/img/breadcrumb/Retouching2.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Retouching2.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    Canvas Options <br />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        <div className="tp-blog__area p-relative  pt-50 pb-40">
          <div className="container">
            <div className="row">
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/customEnhancements'}> 
                    <img
                        className="w-100"
                        src="assets/img/blog/blog1-1.png"
                        alt=""
                      />
                    </Link> 
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                    <Link to={'/customEnhancements'}> Custom Enhancements     </Link> 
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, choose a size, and we’ll ship your
                        beautiful Custom prints to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>
                        Prints starts at $25
                      </span>
                    </div>
                    <div className="tp-blog__link">
                    <Link to={'/customEnhancements'}> Shop Custom Enhancements     </Link> 
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/galleryWraps'}>
                      <img
                        className="w-100"
                        src="assets/img/blog/blog1-2.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={'/galleryWraps'}>Gallery Wraps</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, choose a size, and we’ll ship your
                        beautiful canvas prints to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>
                        Prints starts at $25
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={'/galleryWraps'}>Shop Gallery Wraps</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/retouching'}>
                      <img
                        className="w-100"
                        src="assets/img/blog/blog1-3.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={'/retouching'}>Retouching</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, see beautiful touches on your photos and we'll have it
                        shipped to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>Price Starts at $49</span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={'/retouching'}>Shop Retouching</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/splitCanvases'}>
                      <img
                        className="w-100"
                        src="assets/img/blog/blog1-1.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={'/splitCanvases'}>Split Canvases</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, choose a size, and we’ll ship your
                        beautiful canvas prints to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>
                        Prints starts at $25
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={'/splitCanvases'}>Shop Split Canvases</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/galleryWalls'}>
                      <img
                        className="w-100"
                        src="assets/img/blog/blog1-2.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={'/galleryWalls'}>Gallery Walls</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, choose a size, and we’ll ship your
                        beautiful canvas prints to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>
                        Prints starts at $25
                      </span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={'/galleryWalls'}>Shop Gallery Walls</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-4 col-md-6 mb-40  wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
                style={{
                  visibility: "visible",
                  animationDuration: "0.9s",
                  animationDelay: "0.3s",
                  animationName: "tpfadeUp",
                }}
              >
                <div className="tp-blog__item">
                  <div className="tp-blog__thumb">
                    <Link to={'/storyCanvas'}>
                      <img
                        className="w-100"
                        src="assets/img/blog/blog1-3.png"
                        alt=""
                      />
                    </Link>
                  </div>
                  <div className="tp-blog__content">
                    <h5 className="tp-blog__title">
                      <Link to={'/storyCanvas'}>Story Canvas</Link>
                    </h5>
                    <div className="tp-blog__meta">
                      <span>
                        Upload photos, see your beautiful tray and we'll have it
                        shipped to your door.
                      </span>
                    </div>
                    <div className="tp-blog__meta">
                      <span style={{ fontWeight: 800 }}>Price Starts at $49</span>
                    </div>
                    <div className="tp-blog__link">
                      <Link to={'/storyCanvas'}>Shop Story Canvas</Link>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>

        <UpperFooterSlider />
      </main>
    </div>
  );
}
